import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_SurveyView = _resolveComponent("SurveyView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, { page: _ctx.survey_name }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.patients'),
          to: "/patients"
        }, null, 8 /* PROPS */, ["page"]),
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.patient'),
          to: `/patient/${_ctx.patient_id}`
        }, null, 8 /* PROPS */, ["page", "to"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page"]),
    _createVNode(_component_SurveyView, {
      survey: _ctx.survey,
      patient_id: _ctx.patient_id!
    }, null, 8 /* PROPS */, ["survey", "patient_id"])
  ], 64 /* STABLE_FRAGMENT */))
}